import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "filterForm", 
    "searchInput", 
    "statusFilter", 
    "typeFilter", 
    "dateFilter", 
    "requesterFilter", 
    "resetButton", 
    "tableBody", 
    "loadingIndicator"
  ]

  connect() {
    console.log("Leave request controller connected")
    this.setupDateRangePicker()
    this.updateResetButtonVisibility()
  }

  setupDateRangePicker() {
    if (typeof flatpickr === 'function' && this.hasDateFilterTarget) {
      this.datepicker = flatpickr(this.dateFilterTarget, {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "j F Y",
        locale: document.documentElement.lang,
        onChange: () => this.submitFilter()
      })
    }
  }

  // Debounced search to avoid too many requests
  search() {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      this.submitFilter()
    }, 500)
  }

  // Filter by status or type
  filter() {
    this.submitFilter()
  }

  // Submit the filter form
  submitFilter() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove('hidden')
    }
    
    this.updateResetButtonVisibility()
    
    // Submit form
    this.filterFormTarget.requestSubmit()
  }

  // Reset all filters
  resetFilters(event) {
    event.preventDefault()
    
    // Reset search input
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
    }
    
    // Reset status filter
    if (this.hasStatusFilterTarget) {
      this.statusFilterTarget.value = ''
    }
    
    // Reset type filter
    if (this.hasTypeFilterTarget) {
      this.typeFilterTarget.value = ''
    }
    
    // Reset requester filter
    if (this.hasRequesterFilterTarget) {
      this.requesterFilterTarget.value = ''
    }
    
    // Reset date filter
    if (this.hasDateFilterTarget && this.datepicker) {
      this.datepicker.clear()
    }
    
    this.submitFilter()
  }

  // Update reset button visibility based on filter values
  updateResetButtonVisibility() {
    if (!this.hasResetButtonTarget) return
    
    const hasFilters = (
      (this.hasSearchInputTarget && this.searchInputTarget.value) ||
      (this.hasStatusFilterTarget && this.statusFilterTarget.value) ||
      (this.hasTypeFilterTarget && this.typeFilterTarget.value) ||
      (this.hasRequesterFilterTarget && this.requesterFilterTarget.value) ||
      (this.hasDateFilterTarget && this.dateFilterTarget.value)
    )
    
    if (hasFilters) {
      this.resetButtonTarget.classList.remove('hidden')
    } else {
      this.resetButtonTarget.classList.add('hidden')
    }
  }
}